<form [formGroup]="form" (ngSubmit)="submitStorno()" class="p-4">
  <div class="relative mb-4" [ngClass]="form.controls['stornoComment'].touched ? (form.controls['stornoComment'].errors ? 'has-error' : 'has-success') : ''">
    <label for="stornoComment">{{ "e-invoice.stornoComment" | translate }}:</label>
    <input type="text" placeholder="{{ 'e-invoice.stornoComment' | translate }}" class="form-input rtl:pr-10" id="stornoComment" formControlName="stornoComment" #stornoCommentInput />
    <ng-container *ngIf="form.controls['stornoComment'].touched && form.controls['stornoComment'].errors">
      <small class="mt-1 text-danger">{{ "e-invoice.please_stornoComment" | translate }}</small>
    </ng-container>
  </div>
  <button type="submit" class="btn btn-primary w-full" [disabled]="loading">
    <ng-container *ngIf="!loading; else loadingTemplate">{{ "save" | translate }} </ng-container>
    <ng-template #loadingTemplate>
      <span class="border-blue inline-block h-5 w-5 animate-spin rounded-full border-2 border-l-transparent align-middle ltr:mr-4 rtl:ml-4"></span>{{ "loading" | translate }}
    </ng-template>
  </button>
</form>
